import { FallbackError } from "@core/domain/errors/fallback.error";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteBudgetCategoryConceptUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) {}

    async execute(id: number): Promise<boolean | FallbackError> {
        const result = await this.budgetRepository.deleteCategoryConcept(id);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.isRight();
    }
}
